import IdeyaModal from '../../../../common/antd/ideya-modal.tsx'
import { useTranslation } from 'react-i18next'
import {
  FirmManagementForm,
  FirmManagementFormFieldTypes,
} from './firm-management-form.tsx'
import { FormInstance } from 'antd/lib'
import { useGetFirmDetailQuery } from '../../../../apis/firm-management/firm-management-api.api.ts'
import React, { useEffect } from 'react'
import { FirmType } from '../../../../enums/management-input.enum.ts'
import { IdeyaSpinner } from '../../../../common/components/ideya-spinner.tsx'

interface ActionFirmModalProps {
  showActionModal: boolean
  handleCloseModal: () => void
  form: FormInstance<FirmManagementFormFieldTypes>
  editFirmId?: string | null
  setEditFirmId: (id: string | null) => void
}

export const ActionFirmModal: React.FC<ActionFirmModalProps> = ({
  showActionModal,
  handleCloseModal,
  form,
  editFirmId,
  setEditFirmId,
}) => {
  const { t } = useTranslation()
  const {
    currentData: editFirm,
    isLoading: isLoadingEdit,
    isFetching: isFetchingEdit,
  } = useGetFirmDetailQuery(editFirmId ?? '', { skip: !editFirmId })

  useEffect(() => {
    if (editFirm) {
      form.setFieldsValue({
        name: editFirm.data.name,
        type: editFirm.data.type as FirmType,
        ranked: editFirm.data.ranked,
      })
    }
  }, [editFirmId, editFirm, form])

  const handleCloseAndClear = () => {
    setEditFirmId(null)
    handleCloseModal()
    form.resetFields()
  }

  return (
    <IdeyaModal
      open={showActionModal}
      title={t(
        editFirmId
          ? 'firm_management.firm_modal.edit_firm'
          : 'firm_management.firm_modal.add_firm'
      )}
      destroyOnClose
      isForm={true}
      onCancel={handleCloseAndClear}
    >
      {isFetchingEdit || isLoadingEdit ? (
        <IdeyaSpinner />
      ) : (
        <FirmManagementForm
          editFirm={editFirm?.data}
          mode={editFirmId ? 'edit' : 'create'}
          onCancel={handleCloseAndClear}
          form={form}
        />
      )}
    </IdeyaModal>
  )
}
